// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_TrY","cls2":"blurred_takeaways-cls2_uWW blurred_takeaways-cls1_TrY"};